import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-mv",
  "use": "icon-icon-mv-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-mv\">\n  <path fill=\"#d21034\" d=\"M0 0h512v512H0z\" />\n  <path fill=\"#007e3a\" d=\"M128 128h256v256H128z\" />\n  <circle cx=\"288\" cy=\"256\" r=\"85.3\" fill=\"#fff\" />\n  <ellipse cx=\"308.6\" cy=\"256\" fill=\"#007e3a\" rx=\"73.9\" ry=\"85.3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol